<div class="spinner" *ngIf="isLoading">
</div>